export class PoiNameTranslations {
  static nameMap: ReadonlyMap<string, string> = new Map<string, string>([
    ['alcohol', $localize`:@@poi.alcohol:Alcohol`],
    ['alpine-hut', $localize`:@@poi.alpine-hut:Alpine hut`],
    //['american-football', $localize`:@@poi.american-football:American football`],
    ['apartment', $localize`:@@poi.apartment:Apartment`],
    ['arts-centre', $localize`:@@poi.arts-centre:Arts centre`],
    ['artwork', $localize`:@@poi.artwork:Artwork`],
    ['atm', $localize`:@@poi.atm:Atm`],
    ['attraction', $localize`:@@poi.attraction:Attraction`],
    ['bakery', $localize`:@@poi.bakery:Bakery`],
    ['bank', $localize`:@@poi.bank:Bank`],
    ['bar', $localize`:@@poi.bar:Bar`],
    ['baseball', $localize`:@@poi.baseball:Baseball`],
    ['basketball', $localize`:@@poi.basketball:Basketball`],
    ['bbq', $localize`:@@poi.bbq:BBQ`],
    ['beauty', $localize`:@@poi.beauty:Beauty`],
    ['bench', $localize`:@@poi.bench:Bench`],
    ['beverages', $localize`:@@poi.beverages:Beverages`],
    ['bicycle', $localize`:@@poi.bicycle:Bicycle`],
    ['bicycle-parking', $localize`:@@poi.bicycle-parking:Bicycle parking`],
    ['bicycle-rental', $localize`:@@poi.bicycle-rental:Bicycle rental`],
    ['bicycle-rental-2', $localize`:@@poi.bicycle-rental:Bicycle rental`],
    ['biergarten', $localize`:@@poi.biergarten:Biergarten`],
    ['books-stationary', $localize`:@@poi.books-stationary:Books/stationary`],
    ['boundary-stone', $localize`:@@poi.boundary-stone:Boundary stone`],
    ['buddhist-temple', $localize`:@@poi.buddhist-temple:Buddhist temple`],
    ['busstop', $localize`:@@poi.busstop:Bus stop`],
    ['butcher', $localize`:@@poi.butcher:Butcher`],
    ['cafe', $localize`:@@poi.cafe:Cafe`],
    ['campsite', $localize`:@@poi.campsite:Camp site`],
    ['car', $localize`:@@poi.car:Car`],
    ['casino', $localize`:@@poi.casino:Casino`],
    ['castle', $localize`:@@poi.castle:Castle`],
    ['cemetery', $localize`:@@poi.cemetery:Cemetery`],
    ['chalet', $localize`:@@poi.chalet:Chalet`],
    ['cheese', $localize`:@@poi.cheese:Cheese`],
    ['chemist', $localize`:@@poi.chemist:Chemist`],
    ['chocolate', $localize`:@@poi.chocolate:Chocolate`],
    ['church', $localize`:@@poi.church:Church`],
    ['cinema', $localize`:@@poi.cinema:Cinema`],
    ['clinic', $localize`:@@poi.clinic:Clinic`],
    ['clothes', $localize`:@@poi.clothes:Clothes`],
    ['coffee', $localize`:@@poi.coffee:Coffee`],
    ['confectionery', $localize`:@@poi.confectionery:Confectionery`],
    ['copyshop', $localize`:@@poi.copyshop:Copyshop`],
    ['cosmetics', $localize`:@@poi.cosmetics:Cosmetics`],
    ['cycling', $localize`:@@poi.cycling:Cycling`],
    ['dairy', $localize`:@@poi.dairy:Dairy`],
    ['defibrillator', $localize`:@@poi.defibrillator:Defibrillator`],
    ['deli', $localize`:@@poi.deli:Deli`],
    ['departmentstore', $localize`:@@poi.departmentstore:Department store`],
    ['diy-hardware', $localize`:@@poi.diy-hardware:DIY hardware`],
    ['drinking-water', $localize`:@@poi.drinking-water:Drinking water`],
    ['ebike-charging', $localize`:@@poi.ebike-charging:Ebike charging`],
    ['embassy', $localize`:@@poi.embassy:Embassy`],
    ['fastfood', $localize`:@@poi.fastfood:Fast food`],
    ['firestation', $localize`:@@poi.firestation:Firestation`],
    ['foodcourt', $localize`:@@poi.foodcourt:Food court`],
    ['fuel', $localize`:@@poi.fuel:Fuel`],
    ['gallery', $localize`:@@poi.gallery:Gallery`],
    ['garden-centre', $localize`:@@poi.garden-centre:Garden centre`],
    ['general', $localize`:@@poi.general:General`],
    ['gift', $localize`:@@poi.gift:Gift`],
    ['golf', $localize`:@@poi.golf:Golf`],
    ['grocery', $localize`:@@poi.grocery:Grocery`],
    ['guesthouse', $localize`:@@poi.guesthouse:Guest house`],
    ['gymnastics', $localize`:@@poi.gymnastics:Gymnastics`],
    ['hairdresser', $localize`:@@poi.hairdresser:Hairdresser`],
    ['heritage', $localize`:@@poi.heritage:Heritage`],
    ['hindu-temple', $localize`:@@poi.hindu-temple:Hindu temple`],
    ['historic', $localize`:@@poi.historic:Historic`],
    ['hockey', $localize`:@@poi.hockey:Hockey`],
    ['horseracing', $localize`:@@poi.horseracing:Horse racing`],
    ['hospital', $localize`:@@poi.hospital:Hospital`],
    ['hostel', $localize`:@@poi.hostel:Hostel`],
    ['hotel', $localize`:@@poi.hotel:Hotel`],
    ['icecream', $localize`:@@poi.ice-cream:Ice cream`],
    ['icehockey', $localize`:@@poi.icehockey:Ice hockey`],
    ['information', $localize`:@@poi.information:Information`],
    ['jewelry', $localize`:@@poi.jewelry:Jewelry`],
    ['kiosk', $localize`:@@poi.kiosk:Kiosk`],
    ['leather', $localize`:@@poi.leather:Leather`],
    ['library', $localize`:@@poi.library:Library`],
    ['marketplace', $localize`:@@poi.marketplace:Marketplace`],
    ['monumental-tree', $localize`:@@poi.monumental-tree:Monumental tree`],
    ['monument-memorial', $localize`:@@poi.monument-memorial:Monument`],
    ['mosque', $localize`:@@poi.mosque:Mosque`],
    ['motel', $localize`:@@poi.motel:Motel`],
    ['museum', $localize`:@@poi.museum:Museum`],
    //['musical-instrument',$localize`:@@poi.musical-instrument:Musical instrument`],
    ['musicschool', $localize`:@@poi.musicschool:Music school`],
    ['optician', $localize`:@@poi.optician:Optician`],
    ['organic', $localize`:@@poi.organic:Organic`],
    ['parking', $localize`:@@poi.parking:Parking`],
    ['pets', $localize`:@@poi.pets:Pets`],
    ['pharmacy', $localize`:@@poi.pharmacy:Pharmacy`],
    ['phone', $localize`:@@poi.phone:Phone`],
    ['photo', $localize`:@@poi.photo:Photo`],
    ['picnic', $localize`:@@poi.picnic:Picnic`],
    ['place-of-worship', $localize`:@@poi.place-of-worship:Place of worship`],
    ['police', $localize`:@@poi.police:Police`],
    ['postbox', $localize`:@@poi.postbox:Post box`],
    ['postoffice', $localize`:@@poi.postoffice:Post office`],
    ['pub', $localize`:@@poi.pub:Pub`],
    ['restaurant', $localize`:@@poi.restaurant:Restaurant`],
    ['sauna', $localize`:@@poi.sauna:Sauna`],
    ['seafood', $localize`:@@poi.seafood:Seafood`],
    ['shoes', $localize`:@@poi.shoes:Shoes`],
    ['shoppingcentre', $localize`:@@poi.shoppingcentre:Shopping centre`],
    ['soccer', $localize`:@@poi.soccer:Soccer`],
    ['sportscentre', $localize`:@@poi.sportscentre:Sports centre`],
    ['statue', $localize`:@@poi.statue:Statue`],
    ['supermarket', $localize`:@@poi.supermarket:Supermarket`],
    ['surfing', $localize`:@@poi.surfing:Surfing`],
    ['swimming', $localize`:@@poi.swimming:Swimming`],
    ['synagogue', $localize`:@@poi.synagogue:Synagogue`],
    ['taxi', $localize`:@@poi.taxi:Taxi`],
    ['tennis', $localize`:@@poi.tennis:Tennis`],
    ['textiles', $localize`:@@poi.textiles:Textiles`],
    ['theatre', $localize`:@@poi.theatre:Theatre`],
    ['themepark', $localize`:@@poi.themepark:Themepark`],
    ['toilets', $localize`:@@poi.toilets:Toilets`],
    ['tourism', $localize`:@@poi.tourism:Tourism`],
    ['toys', $localize`:@@poi.toys:Toys`],
    ['travelagency', $localize`:@@poi.travelagency:Travelagency`],
    ['university', $localize`:@@poi.university:University`],
    ['viewpoint', $localize`:@@poi.viewpoint:Viewpoint`],
    ['vineyard', $localize`:@@poi.vineyard:Vineyard`],
    ['volleyball', $localize`:@@poi.volleyball:Volleyball`],
    ['watermill', $localize`:@@poi.watermill:Watermill`],
    ['wayside-shrine', $localize`:@@poi.wayside-shrine:Wayside shrine`],
    ['windmill', $localize`:@@poi.windmill:Windmill`],
    ['wine', $localize`:@@poi.wine:Wine`],
    ['zoo', $localize`:@@poi.zoo:Zoo`],
  ]);
}
